import firebaseService from 'utils/firebase/firebase';

const getRemoteConfigValue = (remoteConfigKey) => {
  return firebaseService.remoteConfig.getValue(remoteConfigKey);
};

export default getRemoteConfigValue;
